export const projectName = "Woow Destinations";
export const email = "hello@woowdestinations.com";
export const themeColor = "#10a5b2";
export const ratingColor = "#f78f08";
export const googleClientId = "634800253131-50kb6h6u5j9k1qvvtjnhassan4usblcv.apps.googleusercontent.com";
export const googleClientSecret = "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";
export const googleMapApiKey = "AIzaSyAhf6IGLhFAbwKMH3ExQE2JELycSkl-oq0";